var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { iconsSvg, typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSteps } from "../../utils/getSteps";
import { PaymentHeader } from "./ui/header";
import { getCustomerAction, isAcap, isAlnap, isApapAuto } from "../../fnx/customer";
import { policyCreateClearData } from "../../store/policy/actions";
import { dataFilter, paymentSummaryStorybook } from "./resources/paymentSummaryDto";
import { PaymentSummaryView } from "./ui/view";
import { Customer } from "../../enum/customer";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { quoteOne } from "../../store/generateQuote/actions";
import { personByIdClearData } from "../../store/person/actions";
import { catalogAccountTypeClearData } from "../../store/plan/actions";
import usePaymentSummary from "./components/paymentSummary";
import useUI from "./components/ui";
import useSelectors from "./components/selectors";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { formatToTwoDecimals } from "../../utils/getPrice";
import { addToSummary } from "ah_utility/fnxUtils";
import { isVidaActiva } from "../../utils/isVidaActiva";
import { useReprintCertificates } from "./hooks/useReprintCertificates";
var PaymentSummary = function () {
    var _a, _b, _c;
    var steps2 = useGetSteps();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var quoteIdParam = useParams().id;
    var t = useTranslation().t;
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(""), accountName = _e[0], setAccountName = _e[1];
    var _f = useState(""), accountType = _f[0], setAccountType = _f[1];
    var _g = useState([]), accountList = _g[0], setAccountList = _g[1];
    var _h = useState(""), personId = _h[0], setPersonId = _h[1];
    var _j = useState(""), accountNumber = _j[0], setAccountNumber = _j[1];
    var _k = useState(false), personTrigger = _k[0], setPersonTrigger = _k[1];
    var _l = React.useState([]), steps = _l[0], setSteps = _l[1];
    var _m = useState(""), subTitlePayment = _m[0], setSubTitlePayment = _m[1];
    var _o = useState([]), listAccountTypes = _o[0], setListAccountTypes = _o[1];
    var _p = React.useState([]), breadCrumbs = _p[0], setBreadCrumbs = _p[1];
    var _q = useState({}), dataFormPayment = _q[0], setDataFormPayment = _q[1];
    var _r = React.useState(""), projectId = _r[0], setProjectId = _r[1];
    var _s = useState(false), cardSelected = _s[0], setCardSelected = _s[1];
    var _t = useState(false), nextDisabled = _t[0], setNextDisabled = _t[1];
    var company = findParamInLocalStorage("subdomain");
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quote = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var quoteId = localStorage.getItem("Quote");
    var _u = React.useState(""), policyId = _u[0], setPolicyId = _u[1];
    var _v = React.useState(""), paymentCurrency = _v[0], setPaymentCurrency = _v[1];
    var _w = React.useState(null), customerAccount = _w[0], setCustomerAccount = _w[1];
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.find(function (flag) { return flag.name === "afy-create-policy-pending-status"; });
    // Si encuentra el flag Y su value es "true", retorna true; caso contrario, retorna false
    var createPolicyPendingStatus = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var isTravelInsurance = (_a = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (flag) { return flag.name === "afy-show-plan-travel-range-info"; })) !== null && _a !== void 0 ? _a : false;
    var isOnlyPaymentCreditCard = (_b = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (flag) { return flag.name === "afy-payment-credit-card-only"; })) !== null && _b !== void 0 ? _b : false;
    var isVidaActivaFlow = isVidaActiva();
    var planName = (Plan === null || Plan === void 0 ? void 0 : Plan.name) || "";
    var _x = useState([]), paymentListOptions = _x[0], setPaymentListOptions = _x[1];
    var _y = useState({
        id: "",
        name: "",
        option: 0,
    }), paymentListOption = _y[0], setPaymentListOption = _y[1];
    var _z = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _z[0], setSeeToast = _z[1];
    var _0 = useState({
        Name: "",
        LastNames: "",
        DocumentNumber: "",
        Email: "",
        Insurance: "",
        PlanTypeName: "",
        CampaignName: "",
        CoverType: "",
        PaymentMode: "",
        Currency: "",
        Prima: "",
        QuoteId: "",
    }), dataForm = _0[0], setDataForm = _0[1];
    var _1 = useReprintCertificates(), reprintCertificates = _1.reprintCertificates, loadingReprintCertificates = _1.loadingReprintCertificates, responseReprintCertificates = _1.responseReprintCertificates, errorReprintCertificates = _1.errorReprintCertificates;
    var _2 = useSelectors(trigger, projectId, personTrigger, personId), responseOneQuote = _2.responseOneQuote, loadingOneQuote = _2.loadingOneQuote, errorOneQuote = _2.errorOneQuote, responsePersonById = _2.responsePersonById, loadingPersonById = _2.loadingPersonById, responseCreatePolicy = _2.responseCreatePolicy, loadingCreatePolicy = _2.loadingCreatePolicy, errorCreatePolicy = _2.errorCreatePolicy, responseCatalogAccountType = _2.responseCatalogAccountType, errorCatalogAccountType = _2.errorCatalogAccountType;
    var _3 = usePaymentSummary(dataForm, responseOneQuote, company, accountType, accountName, accountNumber, cardSelected, setSubTitlePayment, setDataFormPayment, setCardSelected, setSeeToast, createPolicyPendingStatus, isOnlyPaymentCreditCard, quoteIdParam, policyId, paymentCurrency), handleChangePayment = _3.handleChangePayment, createPolicy = _3.createPolicy, loadingComplete = _3.loadingComplete, loadingUpdatePaymentMethod = _3.loadingUpdatePaymentMethod, responseUpdatePaymentMethod = _3.responseUpdatePaymentMethod, errorUpdatePaymentMethod = _3.errorUpdatePaymentMethod;
    var _4 = useUI(navigate, setAccountType, setAccountNumber, setAccountName, setCardSelected), clickCard = _4.clickCard, handlePrevious = _4.handlePrevious;
    useEffect(function () {
        setTrigger(true);
        dispatch(quoteOne({
            id: quoteIdParam || quote || quoteId,
            fullBody: true,
        }));
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        if (responseOneQuote) {
            setPolicyId((_a = responseOneQuote.policyId) === null || _a === void 0 ? void 0 : _a.id);
            setPaymentCurrency((_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.customerAccount) === null || _b === void 0 ? void 0 : _b.paymentCurrency);
            setCustomerAccount((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.customerAccount) !== null && _c !== void 0 ? _c : null);
            setDataForm({
                Name: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameB),
                LastNames: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameB),
                DocumentNumber: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.numberId,
                Email: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.email,
                Insurance: (_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.productId) === null || _d === void 0 ? void 0 : _d.description,
                PlanTypeName: (_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _e === void 0 ? void 0 : _e.name,
                CampaignName: (_f = responseOneQuote.campaignId) === null || _f === void 0 ? void 0 : _f.name,
                CoverType: (_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.coverType) === null || _g === void 0 ? void 0 : _g.description,
                PaymentMode: (_h = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.catalogPaymentMode) === null || _h === void 0 ? void 0 : _h.description,
                Currency: isTravelInsurance
                    ? "USD"
                    : getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                        ? (_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _j === void 0 ? void 0 : _j.currencySymbol
                        : (_l = (_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _k === void 0 ? void 0 : _k.price) === null || _l === void 0 ? void 0 : _l.currencySymbol,
                Prima: isTravelInsurance
                    ? ((_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _m === void 0 ? void 0 : _m.premium) != null
                        ? "USD ".concat(responseOneQuote.contentMap.premium)
                        : "0.00"
                    : getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                        ? ((_o = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _o === void 0 ? void 0 : _o.amount)
                            ? formatToTwoDecimals((_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _p === void 0 ? void 0 : _p.amount)
                            : "0.00"
                        : (_r = (_q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _q === void 0 ? void 0 : _q.price) === null || _r === void 0 ? void 0 : _r.amount,
                QuoteId: responseOneQuote.id,
            });
            setPersonId((_t = (_s = responseOneQuote.insured) === null || _s === void 0 ? void 0 : _s.personId) !== null && _t !== void 0 ? _t : responseOneQuote.personId);
            setPersonTrigger(true);
            setProjectId(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId.projectId);
        }
    }, [responseOneQuote, company]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (errorUpdatePaymentMethod) {
            showErrorToast(errorUpdatePaymentMethod, setSeeToast, t);
        }
    }, [errorUpdatePaymentMethod]);
    useEffect(function () {
        if (responseUpdatePaymentMethod) {
            reprintCertificates(quoteIdParam !== null && quoteIdParam !== void 0 ? quoteIdParam : "");
        }
    }, [responseUpdatePaymentMethod]);
    useEffect(function () {
        if (responseReprintCertificates) {
            navigate("/checkout/payment-confirmation/".concat(quoteIdParam));
        }
    }, [responseReprintCertificates]);
    useEffect(function () {
        if (errorReprintCertificates) {
            showErrorToast(errorReprintCertificates, setSeeToast, t);
        }
    }, [errorReprintCertificates]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a;
        if (isTravelInsurance && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _a === void 0 ? void 0 : _a.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.contentMap) === null || _c === void 0 ? void 0 : _c.premium]);
    var markMatchingAccount = function (list) {
        var _a, _b;
        if (!quoteIdParam)
            return list;
        if (!customerAccount)
            return list;
        var visibleDigits = (_a = customerAccount.accountNumber) === null || _a === void 0 ? void 0 : _a.replace(/\*/g, "").trim();
        var accountName = ((_b = customerAccount.accountName) === null || _b === void 0 ? void 0 : _b.trim()) || null;
        return list.map(function (account) {
            var _a, _b;
            var number = (_a = account.cardValues[1]) !== null && _a !== void 0 ? _a : "";
            var category = (_b = account.cardValues[2]) !== null && _b !== void 0 ? _b : "";
            var numberMatch = visibleDigits && number.endsWith(visibleDigits);
            var nameMatch = !accountName || category === accountName;
            return numberMatch && nameMatch
                ? __assign(__assign({}, account), { disabled: true }) : account;
        });
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responsePersonById === null || responsePersonById === void 0 ? void 0 : responsePersonById.data) {
            setSubTitlePayment("");
            if (getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")) {
                if (!((_b = (_a = responsePersonById.data.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.length)) {
                    showToastSuccessMessage("Este cliente no tiene cuentas activas asociadas para realizar pagos.", typeAlert.info, setSeeToast);
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        if (isOnlyPaymentCreditCard) {
                            setSubTitlePayment("No hay cuentas de tarjeta de crédito disponibles para hacer el pago");
                        }
                        else {
                            setSubTitlePayment("No. Recibo de pagos");
                            setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                            setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                        }
                    }
                }
                else {
                    var accountListNew = ((_d = (_c = responsePersonById.data.additionalContentMap) === null || _c === void 0 ? void 0 : _c.accounts) !== null && _d !== void 0 ? _d : [])
                        .filter(function (account) {
                        return !isVidaActivaFlow || account.category !== "MAS_LIMITE";
                    })
                        .map(function (accounts, idx) { return ({
                        id: idx + 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: [accounts.type, accounts.number, accounts.category],
                        iconSvg: iconsSvg.canceledSales,
                    }); });
                    var filteredAccountList = accountListNew.filter(function (account) { return account.cardValues[0] === "CREDIT_CARD"; });
                    if (planName === Customer.FULL ||
                        planName === Customer.AUTO_FULL ||
                        isOnlyPaymentCreditCard) {
                        setAccountList(markMatchingAccount(filteredAccountList));
                    }
                    else {
                        setAccountList(markMatchingAccount(accountListNew));
                    }
                    if (filteredAccountList.length === 0) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                    }
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        if (filteredAccountList.length === 0) {
                            setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        }
                        else {
                            setSubTitlePayment("");
                        }
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        setSubTitlePayment("No. Recibo de pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2); /// se cambio por el de v3
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
                    }
                }
            }
            if (isAlnap(company)) {
                setSubTitlePayment("");
                setListAccountTypes([
                    {
                        id: "1",
                        name: "Cuenta de Ahorro",
                        value: "1",
                    },
                    {
                        id: "2",
                        name: "Cuenta Monetaria",
                        value: "2",
                    },
                ]);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAlnap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAlnap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            if (isAcap(company)) {
                setSubTitlePayment("");
                var mockAccountList = [
                    {
                        id: 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "03102040890", "CHECKING"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 2,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "05500150833", "SAVINGS"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 3,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40224903282", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 4,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40238337121", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                ];
                setAccountList(mockAccountList);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAcap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAcap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            dispatch(personByIdClearData());
        }
    }, [responsePersonById, company]);
    useEffect(function () {
        if (errorCatalogAccountType) {
            showErrorToast(errorCatalogAccountType, setSeeToast, t);
        }
    }, [errorCatalogAccountType]);
    useEffect(function () {
        var _a, _b, _c;
        if (!getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "") &&
            !isAcap(company) &&
            !isAlnap(company)) {
            if (responseCatalogAccountType &&
                ((_a = responseCatalogAccountType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var data = (_b = responseCatalogAccountType.data) === null || _b === void 0 ? void 0 : _b.map(function (account) {
                    var _a;
                    return {
                        id: account.catalogAccountTypeId,
                        value: account.catalogAccountTypeId,
                        name: (_a = account.catalogAccountType) === null || _a === void 0 ? void 0 : _a.description,
                    };
                });
                setListAccountTypes(data);
                dispatch(catalogAccountTypeClearData());
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
            }
            else if (responseCatalogAccountType &&
                ((_c = responseCatalogAccountType.data) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
            }
        }
    }, [responseCatalogAccountType, company]);
    useEffect(function () {
        if (responseCreatePolicy && responseCreatePolicy.data) {
            setNextDisabled(false);
            dispatch(policyCreateClearData());
            dispatch(policyCreateClearData());
        }
    }, [responseCreatePolicy]);
    useEffect(function () {
        if (errorCreatePolicy) {
            showErrorToast(errorCreatePolicy, setSeeToast, t);
            setNextDisabled(true);
        }
    }, [errorCreatePolicy]);
    return (_jsxs(React.Fragment, { children: [_jsx(PaymentHeader, { loading: loadingOneQuote ||
                    loadingPersonById ||
                    loadingComplete ||
                    loadingUpdatePaymentMethod ||
                    loadingReprintCertificates, loadingCreatePolicy: loadingCreatePolicy, breadCrumbs: breadCrumbs, steps: steps2, seeToast: seeToast, setSeeToast: setSeeToast, title: paymentSummaryStorybook.title, hideStep: !!quoteIdParam }), _jsx(PaymentSummaryView, { breadCrumbs: breadCrumbs, steps: steps, seeToast: seeToast, setSeeToast: setSeeToast, accountName: "".concat(dataForm.Name, " ").concat(dataForm.LastNames), nextLabel: paymentSummaryStorybook.nextLabel, options: listAccountTypes, paymentOption: paymentListOption, paymentOptions: paymentListOptions, hideSubTitlePayment: true, subTitlePayment: subTitlePayment, previousLabel: paymentSummaryStorybook.previousLabel, stepProgress: paymentSummaryStorybook.stepProgress, onBack: handlePrevious, filters: dataFilter(dataForm), dataForm: dataForm, onNext: createPolicy, onChangePayment: handleChangePayment, accountList: accountList, onClickCard: clickCard, 
                // voucherMaxLength={isApapAuto(company) ? 12 : 20}
                // voucherMinLength={isApapAuto(company) ? 12 : 1}
                voucherMaxLength: 20, voucherMinLength: 1, voucherIsAlphaNumeric: isApapAuto(company), nextDisabled: nextDisabled, loadingCreatePolicy: loadingCreatePolicy })] }));
};
export default PaymentSummary;
